import type { RouteConfig } from 'vue-router';
import StandardLayout from '@/layouts/standard-layout.vue';

export default [
  {
    path: '/customer-service',
    component: StandardLayout,
    meta: {
      hasNavBarLayout: true,
    },
    children: [
      /**
       * 客服对话C端
       */
      {
        path: '/customer-service/chat',
        meta: {
          title: '在线客服',
          background: '#F5F5F5',
          customNavBar: false,
        },
        component: () => import('@/views/customer-service/chat/index.vue'),
      },
    ],
  },
] as RouteConfig[];
